<template>
  <el-card class="box-card mb-35 overview-profit">
    <div class="title">
      <span class="mr-20">{{ $t('profits.amount') }}</span>
      <span class="close" @click="handleShow">{{ !showOverview ? $t('profits.open') : $t('profits.close')  }}</span>
    </div>
    <hr/>
    <div class="data" v-if="showOverview">
      <el-row>
        <div class="el-col">
          <p style="margin: 0;"><label class="label">{{ $t(`${this.showTitle(type)}`) }}</label></p>
          <span class="amount">{{ dataOverView.totalPoint }} <span class="unit">{{ $t('kokoron') }}</span></span>
        </div>
        <div class="el-col w-50" v-if="type != this.$typeProfit.staff && dataOverView.moneyOffAxis">
          <br>
          <span class="amount">=</span>
        </div>
        <div class="el-col" v-if="type != this.$typeProfit.staff && dataOverView.moneyOffAxis">
          <label class="label">{{ $t('profits.company_amount') }}</label><br>
          <span class="amount">{{ dataOverView.moneyOfCompany }} <span class="unit">円</span> </span><br>
          <span class="kokoron">（{{ dataOverView.pointOfCompany }} <span class="unit">{{ $t('kokoron') }}） </span></span>
        </div>
        <div class="el-col w-50" v-if="type != this.$typeProfit.staff && dataOverView.moneyOffAxis">
          <br>
          <span class="amount">+</span>
        </div>
        <div class="el-col" v-if="type != this.$typeProfit.staff && dataOverView.moneyOffAxis">
          <label class="label">{{ $t('profits.off_axis_amount') }}</label><br>
          <span class="amount">{{ dataOverView.moneyOffAxis }} <span class="unit">円</span> </span><br>
          <span class="kokoron">（{{ dataOverView.pointOffAxis }} <span class="unit">{{ $t('kokoron') }}） </span></span>
        </div>
      </el-row>
      <div class="condition-search-text-profit">
        <el-row>
          <el-col :span="24" class="font-weight-700">{{ $t('profits.search_result', [searchConditionText.result])}}</el-col>
        </el-row>
        <div v-for="(item, index) in searchConditionText.condition" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
  export default {
    emits: ['handleShow'],
    props: {
      dataOverView: { type: Object, required: true, default: {} },
      searchConditionText: { type: Object, required: true, default: {} },
      type: { type: Number, required: false, default: {} },
      showOverview: { type: Boolean, required: true, default: true },
    },
    data() {
      return {
      }
    },
    methods: {
      handleShow() {
        this.$emit('handleShow');
      },
      showTitle(type) {
        if (type === 3) return "profits.total_amount_staff";
        if (type === 2) return "profits.total_amount";
        return "profits.company_amount";
      },
    },
  }
</script>

<style lang="scss">
  .overview-profit {
    .title {
      font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
      letter-spacing: 1.5px;
      color: #000000;
      margin-bottom: 15px;
      font-weight: 700;
    }
    .data {
      margin-top: 20px;
      .label {
        font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
        letter-spacing: 1.2px;
        color: #000000;
        font-weight: 700;
      }
      .amount {
        font: normal normal bold 25px/29px Futura;
        letter-spacing: 0.25px;
        color: #000000
      }
      .kokoron {
        font: normal normal normal 20px/33px Futura;
        letter-spacing: 0.2px;
        color: #000000;
        font-weight: 700;
        display: block;
        margin-top: -8px;
        margin-bottom: 8px;
      }
      .unit {
        font: normal normal bold 13px/33px Futura;
        letter-spacing: 0.13px;
        color: #000000;
      }
    }
  }
</style>
